import { IonButton, IonRouterLink, IonSkeletonText } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import HorizontalScrollMedia from '../HorizontalScrollMedia';
import { ImageWithFallback } from '../ui/fallbackImage';

interface FeaturedEuropeCountriesProps {
  countries: string[];
  isLoading?: boolean;
}

const ExploreEuropeCountries: React.FC<FeaturedEuropeCountriesProps> = ({ countries, isLoading = false }) => {
  const { t } = useTranslation();
  // Internal skeleton loader
  const renderSkeleton = () => (
    <div className="bg-card border rounded-lg shadow-sm overflow-hidden h-full">
      <IonSkeletonText animated style={{ height: '150px' }} />
      <div className="p-4">
        <IonSkeletonText animated style={{ width: '70%', height: '24px' }} />
      </div>
    </div>
  );

  return (
    <>
      <div className="flex justify-between items-center mb-2">
        <h2 className="font-semibold ml-4">{t('Headlines:explore_europe')}</h2>
        <IonButton fill="clear" size="small" routerLink="/s">
          {t('see_all')}
        </IonButton>
      </div>
      <HorizontalScrollMedia>
        {isLoading ? (
          Array(8).fill(0).map((_, i) => (
            <div key={i} className="w-56">
              {renderSkeleton()}
            </div>
          ))
        ) : countries.map((country: string) => (
          <IonRouterLink
            className="cursor-pointer ml-4 overflow-hidden"
            key={country}
            routerLink={`/s/${country.toLowerCase()}`}
          >
            <div className="relative group">
              <ImageWithFallback
                alt={`${country} photo`}
                fallbackImage="/assets/images/fallback.jpg"
                src={`/assets/images/location/${country.toLowerCase()}.webp`}
                className="w-48 h-52 md:w-56 md:h-64 object-cover rounded-md brightness-90"
              />
              <div className="absolute inset-0 shadow-lg flex items-end justify-start p-6">
                <span className="text-white text-xl font-bold" style={{ textShadow: '1px 1px 0 rgba(0,0,0,0.35), 1px 1px 5px rgba(0,0,0,0.5)' }}>{t('Countries:' + country)}</span>
              </div>
            </div>
          </IonRouterLink>
        ))}
      </HorizontalScrollMedia>
    </>
  );
};

export default ExploreEuropeCountries;
